module.exports = __webpack_public_path__ + "static/media/LogoPlaceholder.e0a31f4b.png";